<template>
  <div>
    <h2 class="my-5">
      <b>Verify webpage preview before proceeding</b>
    </h2>
    <div class="p-2 preview-titlebar text-center px-4">
      <i class="fa fa-globe mr-2" />{{ captureURL }}
    </div>
    <div class="image-preview-container border">
      <div v-if="!isComplete" class="d-flex loading-text-container">
        <img class="loading-circle mr-3" src="../assets/images/loading-circle.svg" />
        <div>
          <b>{{ captureProgress }}</b>
        </div>
      </div>
      <div v-else>
        <img class="preview-image" :src="previewImage" alt="Loading preview" @error="getCaptureData()"
          @click="openModal()" />
      </div>
    </div>
    <div v-if="isStepComplete" class="p-4 text-center my-3">
      <h3><b>Is this preview same as expected ?</b></h3>
      <div v-if="previewFailed" class="col-md-10 text-left mx-auto my-4">
        <div class="col-md-8 mx-auto">
          If the preview is <b>not</b> same as expected, it could be due the
          following reasons: <br /><br />
          <ul>
            <li><i>Incorrect URL</i></li>
            <li><i>Content does not exist anymore</i></li>
            <li><i>The website is blocking requests</i></li>
            <li><i>Dynamically loaded content</i></li>
            <li><i>Requires login credintials</i></li>
          </ul>
        </div>
        <br />
        <div class="col-md-8 mx-auto">
          <strong>You can try our on-demand assisted capture to perfectly capture the
            webpage.</strong>
          <br />
        </div>
      </div>
    </div>

    <div class="d-flex pt-5 steps-button" hidden="true">
      <button class="btn back-btn ml-0 mr-auto" @click="nextHandler(1)">
        <i class="fa fa-angle-left mr-2" /> Back
      </button>
      <button v-if="!previewFailed && isStepComplete" class="btn back-btn mr-3" @click="previewNotSame()">
        No
      </button>
      <button v-if="!previewFailed && isStepComplete" class="btn next-btn mr-0" style="max-width: 36vw"
        @click="nextHandler(3)" :disabled="!isStepComplete">
        Yes, Proceed to payment <i class="fa fa-angle-right ml-2" />
      </button>
      <button v-if="previewFailed && isStepComplete" class="btn back-btn mr-1" @click="nextHandler(3)">
        Proceed Anyway <i class="fa fa-angle-right ml-2" />
      </button>
      <button v-if="previewFailed && isStepComplete" class="btn next-btn mr-0" :disabled="!isStepComplete">
        Assisted Capture <i class="fa fa-angle-right ml-2" />
      </button>
    </div>

    <div v-if="isModalVisible" class="modal">
      <span class="close" @click="closeModal()">&times;</span>
      <img class="modal-content" :src="previewImage" alt="Loading preview" />
    </div>
    <transition>
      <div v-if="errorMessage" class="danger-info p-3 my-5">
        <i class="fa fa-exclamation-triangle mr-3" />{{ errorMessage }}
      </div>
    </transition>
  </div>
</template>
<script>
import cfg from "../config"
import timeout from "../functions/timeout"
export default {
  name: "WebCapture",
  props: {
    captureURL: String,
    recaptchaResponse: String,
    nextHandler: Function,
    webCapCB: Function,
  },
  data() {
    return {
      oldCaptureURL: "",
      captureID: null,
      captureProgress: "Starting",
      isComplete: false,
      previewImage: "null",
      isStepComplete: false,
      isModalVisible: false,
      previewFailed: false,
      errorMessage: null
    }
  },
  methods: {
    capture(captureURL, recaptchaResponse) {
      var url =
        `${cfg.captureAPIURL}/capture/ssc-otu/?captureURL=${captureURL}&recaptchaResponse=${recaptchaResponse}`
      let eventSource = new EventSource(url)
      let counter = 0
      eventSource.onmessage = (event) => {
        if (counter < 1) {
          this.captureID = event.data
          counter++
        } else if (event.data === "END") {
          this.getCaptureData()
          eventSource.close()
        } else if (event.data.includes("ERR_NAME_NOT_RESOLVED")) {
          this.errorMessage = "Error loading page. Please check URL."
          this.captureProgress = "Error Loading page"
          eventSource.close()
        }
        else if (event.data.includes("Error verifying captcha")) {
          this.errorMessage = "Error verifying captcha. Please try again"
          this.captureProgress = "Error verifying captcha"
          eventSource.close()
        }
        else if (event.data.includes("Server overload")) {
          this.errorMessage = "Server overload. Please try again"
          this.captureProgress = "Server overload"
          eventSource.close()
        }
        else if (event.data.includes("Error queuing request")) {
          this.errorMessage = "Error queuing request. Please try again"
          this.captureProgress = "Error queuing request"
          eventSource.close()
        }
        else if (event.data.includes("Capture errored")) {
          this.errorMessage = "Error loading page. Please try after sometime."
          this.captureProgress = "Error Loading page"
          eventSource.close()
        }
        else {
          this.captureProgress = event.data
        }
      }
      eventSource.onerror = (error) => {
        this.errorMessage = "Error capturing page. Please try after sometime."
        eventSource.close()
        //this.pollCaptureProgress()  is this needed?
      }
    },
    async pollCaptureProgress() {
      while (!this.isComplete) {
        await this.getCaptureData()
        await timeout()
      }
    },
    getCaptureData() {
      return new Promise((resolve, reject) => {
        this.captureProgress = "Loading preview"
        fetch(`${cfg.dataAPIURL}/data/otu-capture/` + this.captureID)
          .then((res) => res.json())
          .then((data) => {
            if (data.isComplete) {
              this.isComplete = true
              this.isStepComplete = true
              this.previewImage = data.previewImage
              this.webCapCB([data])
            }
            resolve()
          }).catch(error => {
            console.log(error)
            this.errorMessage = "Error loading preview image. Please try after sometime."
          })
      })
    },
    openModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
    previewNotSame() {
      this.previewFailed = true
    },
  },
  activated() {
    if ((this.oldCaptureURL !== this.captureURL) || this.errorMessage != null) {
      this.isComplete = false
      this.errorMessage = null
      this.oldCaptureURL = this.captureURL
      this.isStepComplete = false
      this.captureProgress = "Starting"
      this.capture(this.captureURL, this.recaptchaResponse)
    }
  },
  mounted() {
    this.oldCaptureURL = this.captureURL
    this.capture(this.captureURL, this.recaptchaResponse)
  },
}
</script>
<style scoped>
.image-preview-container {
  min-height: 400px;
  border-radius: 0 0 10px 10px;
  border: 1px solid #eee;
}

.preview-titlebar {
  background: #eee;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: nowrap;
  max-height: 32px;
}

.preview-image {
  width: 100%;
}

.preview-image:hover {
  cursor: pointer;
}

.loading-text-container {
  text-align: center;
  margin-top: 150px;
  margin-bottom: 150px;
  justify-content: center;
}

.loading-circle {
  width: 20px;
  animation: rotation 0.7s infinite linear;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    transform: rotate(359deg);
    opacity: 1;
  }
}

@keyframes glow {
  from {
    opacity: 0.2;
  }

  ro {
    opacity: 1;
  }
}

/* The Modal (background) */
.modal {
  display: block;
  position: fixed;
  /* Stay in place */
  z-index: 1050;
  /* Sit on top */
  padding-top: 100px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background: rgb(0, 0, 0, 0.9);
  margin-right: -30px !important;
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 90%;
  margin-bottom: 100px;
}

body.modal-open {
  overflow-y: hidden;
}

/* Add Animation */

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }

  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/WebCapture.vue